type DownloadArgs = {
  id: string;
  token: string;
  chartId?: string; // Optional, used in downloadAuditZip
  runFlag?:number;
};

// download json
export const triggerDownload = (data: any, filename: string) => {
  const jsonString = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = filename;

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  window.URL.revokeObjectURL(url);
};
// download xlsx
export const downloadAsXlsx=async(data:any,filename:string)=>{
  const blob = await data.blob();
  
      const contentDisposition = data.headers.get("content-disposition");
     
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }
  
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);


}

export async function downloadAuditIdJSON({ id, token }: DownloadArgs) {
  try {
    const response = await fetch(`${import.meta.env.VITE_API_URL}/harvest/download?auditId=${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error(`Audit Id download failed: ${response.statusText}`);

    const blob = await response.blob();

    const zipBlob = new Blob([blob], { type: 'application/zip' });

    const url = window.URL.createObjectURL(zipBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Retrival-${id}.zip`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    // const data = await response.json();
    // debugger
    // triggerDownload(data, `audit-${id}.json`);
  } catch (error: any) {
    console.error('Audit Id Download error:', error);
    alert(`Download failed: ${error.message}`);
  }
}

export async function downloadHarvestIdJSON({ id, token }: DownloadArgs) {
  try {
    const response = await fetch(`${import.meta.env.VITE_API_URL}/harvest/runs/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error(`Harvest Id download failed: ${response.statusText}`);

    const data = await response.json();
    triggerDownload(data, `harvestId-${id}.json`);
  } catch (error: any) {
    console.error('Harvest Id Download error:', error);
    alert(`Download failed: ${error.message}`);
  }
}

export async function downloadAuditZip({ id, token,chartId }: DownloadArgs) {
  try {
    const response = await fetch(`${import.meta.env.VITE_API_URL}/harvest/download?auditId=${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error(`Audit Id download failed: ${response.statusText}`);

    const blob = await response.blob();

    const zipBlob = new Blob([blob], { type: 'application/zip' });

    const url = window.URL.createObjectURL(zipBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `chart_${chartId}.zip`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    // const data = await response.json();
    // debugger
    // triggerDownload(data, `audit-${id}.json`);
  } catch (error: any) {
    console.error('Audit Id Download error:', error);
    alert(`Download failed: ${error.message}`);
  }
}

export async function downloadHarvestZip({ id, token }: DownloadArgs) {
  try {
    const response = await fetch(`${import.meta.env.VITE_API_URL}harvest/runs/download/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error(`Chart Review download failed: ${response.statusText}`);

     const blob = await response.blob();

    const zipBlob = new Blob([blob], { type: 'application/zip' });

    const url = window.URL.createObjectURL(zipBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Retrival_Charts_${id}.zip`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    console.error('Chart Review Download error:', error);
    alert(`Download failed: ${error.message}`);
  }
}
 export const downloadBatchHarvestZip = async ({ id, token, chartId , runFlag}: DownloadArgs) => {
  try {
    const response = await fetch(`${import.meta.env.VITE_API_URL}harvest/runs/batch-download/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error(`Batch Id download failed: ${response.statusText}`);

    // const blob = await response.blob();
     const data = await response.json();

    const zipBlob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });

    const url = window.URL.createObjectURL(zipBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Batch_Summary_${chartId}${runFlag === 1 ? ' (TEST)' :''}.json`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    console.error('Batch Id Download error:', error);
    alert(`Download failed: ${error.message}`);
  }
}
